import { RootState } from '@/Redux/RootReducer';
import { createSelector } from 'reselect';

const translation = (root: RootState) => root.global.translation;

const documentTypesData = (root: RootState) => root.dynamicData.documentTypesData;

const documentTypes = createSelector([documentTypesData, translation], (state, translation) => {
  const documentTypes = translation.Pages.Settings.OnlineArchiveSettings.DocumentCategories.DisabledDocumentTypes;

  return state.documentTypes
    .map((documentType) => ({
      ...documentType,
      name: documentTypes[documentType.name as keyof typeof documentTypes] ?? documentType.name,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
});

const documentTypeOptions = createSelector([documentTypes], (state) => {
  return state.map((item) => ({ key: item.id, value: item.name }));
});

export const documentTypesDataSelectors = {
  documentTypes,
  documentTypeOptions,
};
